import {Image, Text, TouchableOpacity, View} from "react-native";
import React, {memo} from "react";
import styles from "./styles";
import {Placeholder, PlaceholderMedia, Shine} from "rn-placeholder";

function Category (props) {
    function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    function shadeRGB(rgb, shade){
        return "rgba("+rgb['r']+","+rgb['g']+","+rgb['b']+"," + shade +")"
    }

    const rgbColour = hexToRgb(props.color)

    if(props.loading){
        return(
            <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[styles.catImg]} />
            </Placeholder>
        )
    } else {
        return(
            <TouchableOpacity onPress={() => props.showCategory(props.id)}>
                <View style={styles.categoryWrapper}>
                    <Image source={props.imgsrc} style={styles.catImg} />
                        <View style={[styles.catDetails,{backgroundColor:shadeRGB(rgbColour,0.7)}]}>
                            <Text style={styles.catName}>{props.name}</Text>
                            <Text style={styles.catCount}>{props.count} Retailers</Text>
                        </View>
                </View>
            </TouchableOpacity>
        )
    }
}

export default memo(Category);


